'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _groupPanel = require('./group/panel');

var _groupPanel2 = _interopRequireDefault(_groupPanel);

var _homePanel = require('./home/panel');

var _homePanel2 = _interopRequireDefault(_homePanel);

var _fixturePanel = require('./fixture/panel');

var _fixturePanel2 = _interopRequireDefault(_fixturePanel);

var _teamPanel = require('./team/panel');

var _teamPanel2 = _interopRequireDefault(_teamPanel);

var _finalPanel = require('./final/panel');

var _finalPanel2 = _interopRequireDefault(_finalPanel);

var _tournamentPanel = require('./tournament/panel');

var _tournamentPanel2 = _interopRequireDefault(_tournamentPanel);

exports['default'] = {
  '/': _homePanel2['default'],
  '/:tournamentId': _tournamentPanel2['default'],
  '/:tournamentId/la-final': _finalPanel2['default'],
  '/:tournamentId/fixture': _fixturePanel2['default'],
  '/:tournamentId/:groupRef': _groupPanel2['default'],
  '/:tournamentId/:groupRef/:teamId': _teamPanel2['default']
};
module.exports = exports['default'];